import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { ComposeEntryMode, ComposePlan } from "@/lib/manufacturing/composePlan";

export type MfgComposePlanRemoteSummary = {
  id: string;
  status: "open" | "parked" | "completed" | "cancelled";
  recipe_group_id: string | null;
  opened_by_user_id: string | null;
  updated_by_user_id: string | null;
  series_name: string;
  series_code: string;
  entry_mode: ComposeEntryMode;
  step: string;
  product_count: number;
  committed_products: number;
  ready_products: number;
  plan: ComposePlan;
  created_at: string;
  updated_at: string;
};

export function listManufacturingComposePlans(opts?: { handoff_only?: boolean }) {
  const q = new URLSearchParams();
  if (opts?.handoff_only) q.set("handoff_only", "1");
  const suffix = q.toString() ? `?${q.toString()}` : "";
  return manufacturingFetch<{ ok: true; plans: MfgComposePlanRemoteSummary[] }>(
    `/api/mfg/compose-plans${suffix}`,
    { method: "GET" },
  );
}

export function getManufacturingComposePlan(planId: string) {
  const q = new URLSearchParams({ plan_id: planId });
  return manufacturingFetch<{ ok: true; plan: MfgComposePlanRemoteSummary }>(
    `/api/mfg/compose-plans/detail?${q.toString()}`,
    { method: "GET" },
  );
}

export function createManufacturingComposePlan(payload: {
  entry_mode: ComposeEntryMode;
  recipe_group_id?: string | null;
  series_name?: string;
  series_code?: string;
  plan?: ComposePlan;
}) {
  return manufacturingFetch<{ ok: true; plan: MfgComposePlanRemoteSummary }>(
    "/api/mfg/compose-plans/create",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function saveManufacturingComposePlan(payload: {
  plan_id: string;
  plan: ComposePlan;
}) {
  return manufacturingFetch<{ ok: true; plan: MfgComposePlanRemoteSummary }>(
    "/api/mfg/compose-plans/save",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function parkManufacturingComposePlan(payload: {
  plan_id: string;
  plan?: ComposePlan;
}) {
  return manufacturingFetch<{ ok: true; plan: MfgComposePlanRemoteSummary }>(
    "/api/mfg/compose-plans/park",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function resumeManufacturingComposePlan(planId: string) {
  return manufacturingFetch<{ ok: true; plan: MfgComposePlanRemoteSummary }>(
    "/api/mfg/compose-plans/resume",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan_id: planId }),
    },
  );
}

export function completeManufacturingComposePlan(payload: {
  plan_id: string;
  plan?: ComposePlan;
}) {
  return manufacturingFetch<{ ok: true; plan: MfgComposePlanRemoteSummary }>(
    "/api/mfg/compose-plans/complete",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function cancelManufacturingComposePlan(planId: string) {
  return manufacturingFetch<{ ok: true; plan: MfgComposePlanRemoteSummary }>(
    "/api/mfg/compose-plans/cancel",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan_id: planId }),
    },
  );
}
